import gql from 'graphql-tag';

const S_QUESTION_FRAGMENT = gql`
  fragment SQuestionFragment on SQuestion {
    _id
    question
    options
    responses {
      _id
      response
    }
  }
`;

export const FETCH_SURVEY_QUESTIONS_QUERY = gql`
  query fetchSurveyQuestions($organization: ID!) {
    surveyQuestions(_organization: $organization) {
      ...SQuestionFragment
    }
  }
  ${S_QUESTION_FRAGMENT}
`;

export const ADD_SURVEY_QUESTION_MUTATION = gql`
  mutation addSQuestion($sQuestionInput: SQuestionInput!) {
    addSQuestion(input: $sQuestionInput) {
      ...SQuestionFragment
    }
  }
  ${S_QUESTION_FRAGMENT}
`;

export const UPDATE_S_QUESTION_MUTATION = gql`
  mutation updateSQuestion($questionID: ID!, $question: String!, $options: [String]!) {
    updateSQuestion(_question: $questionID, question: $question, options: $options) {
      ...SQuestionFragment
    }
  }
  ${S_QUESTION_FRAGMENT}
`;
//
// export const ADD_S_QUESTION_OPTION_MUTATION = gql`
//   mutation addSQuestionOption($questionID: ID!, $option: String!) {
//     addSQuestionOption(_question: $questionID, option: $option) {
//       ...SQuestionFragment
//     }
//   }
//   ${S_QUESTION_FRAGMENT}
// `;
//
// export const REMOVE_S_QUESTION_OPTION_MUTATION = gql`
//   mutation removeSQuestionOption($questionID: ID!, $option: String!) {
//     updateSQuestion(_question: $questionID, option: $option) {
//       ...SQuestionFragment
//     }
//   }
//   ${S_QUESTION_FRAGMENT}
// `;

export const REMOVES_S_QUESTION_MUTATION = gql`
  mutation removeSQuestion($questionID: ID!) {
    removeSQuestion(_question: $questionID)
  }
`;



// WEBPACK FOOTER //
// ./src/modules/survey/api.js